/**
 * Created by PRIME AI.
 * @author Samuel Hinchliffe <samuel@primeai.co.uk, sam.hinchliffe.work@gmail.com>
 * @see    [Linkedin] {@link https://www.linkedin.com/in/samuel-hinchliffe-2bb5801a5/}
 *
 * @summary We use local storage lots. But we need to be able to set a time to live on the data we store. This class will allow us to do that.
 *
 * Created at: 28/05/2024
 * @see       [PRIME-AI GITHUB] {@link https://github.com/PRIME-AI-GITHUB}
 * @see       [Website]         {@link https://www.primeai.co.uk/}
 * @copyright 2018-2024 PRIME AI LTD
*/

export default class CacheStorage {
    constructor() {
        if (typeof localStorage === 'undefined') {
            throw new Error('LocalStorage is not supported in this environment.');
        }
    }

    static set(key, value, expiration = null) {
        try {
            const payload = {
                value,
                expiration,
            };
            localStorage.setItem(key, JSON.stringify(payload));
            return true;
        } catch (error) {
            console.error(error);
            return false;
        }
    }

    static get(key) {
        const data = localStorage.getItem(key);
        if (data) {
            const { value, expiration } = JSON.parse(data);
            if (!expiration || Date.now() < expiration) {
                return value;
            }
            localStorage.removeItem(key); // Delete expired key
        }
        return null;
    }

    static del(key) {
        return localStorage.removeItem(key);
    }

    static exists(key) {
        return localStorage.getItem(key) !== null;
    }

    static expirationEndOfDay() {
        const endOfDay = new Date();
        endOfDay.setHours(23, 59, 59, 999); // Set the time to the end of the day
        return endOfDay.getTime();// Return the Unix timestamp in ms.
    }
}
